import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { openDialog } from '../../store/actionCreators/dialog';
import Avatar from '../Units/Avatar';
import '../../assets/stylesheets/ProfileSlide/ProfilePage.scss';
import '../../assets/stylesheets/ProfileSlide/ProfileEdition.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "../Units/Header";
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {requestAvatarMenu} from "../../store/actionCreators/avatar";
import {getGlobalAccount, getGlobalAccountAvatar} from "../../store/selectors";
import {Link} from "react-router-dom";

const Edit = ({ }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const globalAccount = useSelector(getGlobalAccount);
    const profileAvatar = useSelector(getGlobalAccountAvatar);

    useEffect(() => {
        dispatch(requestAvatarMenu());
    },[]);

    return (
        <div className={`slide-wrapper profile-edition`}>
            <div className={`profile edit`}>
                <Header title='' backTo={'/profile'} />
                <div className={'avatar-container edit'}>
                    <div className="avatar-block">
                        <div className={`avatar-wrapper`}>
                            <div className={`avatar-main`} onClick={() => dispatch(openDialog('selectAvatar'))}>
                                <Avatar data={profileAvatar}/>
                                <div className={'avatarMask'} >
                                    <span>{t('edit')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className={'fieldSection'}>
                    <div className={`userName editionField`}>
                        {t('nickname')}
                        <label>
                            <input value={globalAccount.username} disabled={true} />
                        </label>
                    </div>
                    <div className={`language editionField`} onClick={() => dispatch(openDialog('selectCountry'))}>
                        {t('country')}
                        <label>
                            <span className={`countryFlag ${'usa'}`}></span>
                            <input value={'United States'} disabled={true} />
                            <span className={`arrowDown`}>
                                <FontAwesomeIcon icon={faChevronDown} color="#fff" />
                            </span>
                        </label>
                    </div>
                </div> */}
                {/* Will be used later */}
                <div className={`confirm`}>
                    <button className={`primary`} > {'Confirm'}</button>
                </div>
            </div>
        </div>
    )
}

export default Edit;
